// A public test profile used for eSIM install tests (it adds a test line, no data plan).
export const PUBLIC_TEST_LPA = 'LPA:1$rsp.truphone.com$QRF-SPEEDTEST';

/** "LPA:1$<SM-DP+ address>$<matching id>" → { lpa, smdp, code }, or null when it isn't an activation code. */
export function parseLpa(text) {
  const m = String(text || '').trim().match(/^LPA:1\$([a-z0-9.-]+\.[a-z]{2,})\$([^\s$]+)$/i);
  return m ? { lpa: `LPA:1$${m[1]}$${m[2]}`, smdp: m[1], code: m[2] } : null;
}
